const getElementsWithHeight = (elements) =>
  elements.map((element) => {
    const { height } = element.getBoundingClientRect();
    return { element, height };
  });

export default getElementsWithHeight;
